import { Dialog } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { FiLock, FiClock } from 'react-icons/fi';

interface SubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpgrade: () => void;
}

export function SubscriptionModal({ isOpen, onClose, onUpgrade }: SubscriptionModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="relative z-50"
    >
      <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" aria-hidden="true" />
      
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-sm rounded-lg bg-base-100 p-6 shadow-xl">
          <div className="flex flex-col items-center text-center">
            <div className="mb-4 rounded-full bg-primary/10 p-3">
              <FiLock className="h-6 w-6 text-primary" />
            </div>
            
            <Dialog.Title className="text-xl font-bold mb-2 text-base-content">
              {t('subscription.modal.title')}
            </Dialog.Title>
            
            <Dialog.Description className="text-base-content/70 mb-4">
              {t('subscription.modal.description')}
            </Dialog.Description>

            <div className="bg-base-200 rounded-lg p-4 mb-4 w-full">
              <div className="text-2xl font-bold text-primary mb-1">
                R$ 9,99
              </div>
              <div className="text-base-content/70 text-sm">
                {t('subscription.modal.perMonth')}
              </div>
            </div>

            <div className="flex items-center gap-2 text-error mb-6 text-sm">
              <FiClock className="h-4 w-4" />
              <span>{t('subscription.modal.promoEnds')}</span>
            </div>
            
            <div className="flex flex-col w-full gap-2">
              <button
                className="btn btn-primary w-full"
                onClick={onUpgrade}
              >
                {t('subscription.modal.upgrade')}
              </button>
              <button
                className="btn btn-ghost btn-sm text-base-content hover:bg-base-200"
                onClick={onClose}
              >
                {t('subscription.modal.cancel')}
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
} 